// Define a class for the Swiper component that extends the HTMLElement class
class PromoBarComponent extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initWhenStylesApply();

    document.addEventListener("shopify:section:load", this.initSwiper.bind(this));
    document.addEventListener("shopify:section:reorder", this.initSwiper.bind(this));
    document.addEventListener("shopify:section:select", this.initSwiper.bind(this));
    document.addEventListener("shopify:block:select", this.initSwiper.bind(this));
  }

  // The Swiper stylesheet loads as media="print" and flips to "all" on load.
  // Initializing before it applies leaves the fade slides positioned for the
  // unstyled layout, so the active slide ends up off-screen and transparent.
  initWhenStylesApply() {
    const swiperStyles = document.querySelector('link[href*="swiper-bundle"]');
    const stylesApplied = !swiperStyles || swiperStyles.media === "all";
    if (stylesApplied) {
      this.initSwiper();
      return;
    }
    const init = () => this.initSwiper();
    swiperStyles.addEventListener("load", init, { once: true });
    swiperStyles.addEventListener("error", init, { once: true });
  }

  initSwiper() {
    const autoplayDelay = this.getAttribute("data-autoplay-delay") || 5000;
    const sliderEffect = this.getAttribute("data-slider-effect") || "fade";

    if (this.swiper && this.swiper.destroy) this.swiper.destroy(true, true);

    this.swiper = new Swiper(this, {
      speed: 400,
      slidesPerView: 1,
      centeredSlides: true,
      loop: true,
      autoplay: {
        delay: parseInt(autoplayDelay),
      },
      effect: sliderEffect,
      fadeEffect: {
        crossFade: true,
      },
    });

    // WCAG 2.2.2: honor reduced-motion — start paused.
    this.reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (this.reducedMotion && this.swiper.autoplay) this.swiper.autoplay.stop();

    this.holdAutoplayUntilInteraction();
    this.initPauseControl();
  }


  // Hold autoplay until the visitor interacts: a first-viewport slider that
  // rotates during load inflates Speed Index and produces long tasks.
  holdAutoplayUntilInteraction() {
    if (!this.swiper || !this.swiper.autoplay || this.reducedMotion) return;
    if (window.__srAutoplayReleased) return;
    this.swiper.autoplay.stop();
    this.autoplayHeld = true;
    if (window.__srAutoplayHoldBound) return;
    window.__srAutoplayHoldBound = true;
    const events = ["pointerdown", "keydown", "touchstart", "wheel"];
    const release = () => {
      window.__srAutoplayReleased = true;
      events.forEach((e) => document.removeEventListener(e, release, true));
      document.querySelectorAll("promo-bar").forEach((el) => {
        if (el.autoplayHeld && el.swiper && el.swiper.autoplay && !el.reducedMotion) {
          el.autoplayHeld = false;
          el.swiper.autoplay.start();
        }
      });
    };
    events.forEach((e) => document.addEventListener(e, release, { passive: true, capture: true }));
  }

  // WCAG 2.2.2 (Pause, Stop, Hide): auto-rotating content needs a user control.
  initPauseControl() {
    const button = this.querySelector(".announcement-bar__pause");
    if (!button) return;

    const setState = (paused) => {
      button.setAttribute(
        "aria-label",
        paused ? "Play announcement rotation" : "Pause announcement rotation"
      );
      button.querySelector(".announcement-bar__pause-icon--pause").classList.toggle("hidden", paused);
      button.querySelector(".announcement-bar__pause-icon--play").classList.toggle("hidden", !paused);
    };

    setState(this.reducedMotion);

    if (!button.dataset.bound) {
      button.dataset.bound = "true";
      button.addEventListener("click", () => {
        const isRunning = this.swiper.autoplay && this.swiper.autoplay.running;
        if (isRunning) {
          this.swiper.autoplay.stop();
        } else {
          this.swiper.autoplay.start();
        }
        setState(isRunning);
      });
    }
  }
}

// Define the custom element
customElements.define("promo-bar", PromoBarComponent);
